export default __webpack_public_path__ + "static/media/Fatine.84b5888c.webp";